/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon24Solid = forwardRef('ArrowParallelHIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.103 2.64A1.5 1.5 0 1 1 16.225.52l3.927 3.927a2.906 2.906 0 0 1 0 4.11l-3.927 3.928a1.5 1.5 0 0 1-2.122-2.121L16.465 8H4.5a1.5 1.5 0 1 1 0-3h11.965l-2.362-2.36Z" }),
        React.createElement("path", { d: "M9.897 13.64a1.5 1.5 0 0 0-2.122-2.122l-3.927 3.928a2.906 2.906 0 0 0 0 4.11l3.927 3.927a1.5 1.5 0 0 0 2.122-2.12L7.535 19H19.5a1.5 1.5 0 1 0 0-3H7.535l2.362-2.361Z" })));
});
